/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready(registration) {
            console.log(
                "App is being served from cache by a service worker.\n" +
                "For more details, visit https://goo.gl/AFskqB"
            );
            //registration.addEventListener('install', (event: Event) => {
            //    (event as ExtendableEvent).waitUntil(
            //        caches.open('v1').then((cache) => {
            //            return cache.addAll([
            //                '/',
            //                '/index.html'
            //            ]);
            //        })
            //    );
            //});

            //registration.addEventListener('activate', (event: Event) => {
            //    (event as ExtendableEvent).waitUntil(
            //        caches.keys().then((cacheNames) => {
            //            return Promise.all(
            //                cacheNames.map((cacheName) => {
            //                    if (cacheName !== 'v1') {
            //                        return caches.delete(cacheName);
            //                    }
            //                })
            //            );
            //        })
            //    );
            //});

            //registration.addEventListener('fetch', (event: Event) => {
            //    const fetchEvent = (event as FetchEvent)
            //    fetchEvent.respondWith(
            //        fetch(fetchEvent.request)
            //            .then((response) => {
            //                if (!response || response.status !== 200 || response.type !== 'basic') {
            //                    return response;
            //                }

            //                const responseToCache = response.clone();

            //                caches.open('v1')
            //                    .then((cache) => {
            //                        // Don't cache if the URL includes a hash
            //                        if (!fetchEvent.request.url.includes('chunk-')) {
            //                            cache.put(fetchEvent.request, responseToCache);
            //                        }
            //                    });

            //                return response;
            //            })
            //        //.catch((error) => {
            //        //    return caches.match(fetchEvent.request);
            //        //})
            //    );
            //});
        },
        registered() {
            console.log("Service worker has been registered.");
        },
        cached() {
            console.log("Content has been cached for offline use.");
        },
        updatefound() {
            console.log("New content is downloading.");
        },
        updated() {
            console.log("New content is available; please refresh.");
        },
        offline() {
            console.log(
                "No internet connection found. App is running in offline mode."
            );
        },
        error(error) {
            console.error("Error during service worker registration:", error);
        },
    });
}
